import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-osd text-sm text-[#fc1c46] animate-pulse" data-testid="auth-loading">
          VÉRIFICATION…
        </div>
      </div>
    );
  }
  if (user === null) {
    // Nouveau projet sans session : /start ouvre une session sans compte
    if (location.pathname === "/studio" && new URLSearchParams(location.search).has("new")) return <Navigate to="/start" replace />;
    return <Navigate to="/login" state={{ from: location.pathname + location.search + location.hash }} replace />;
  }
  return children;
}
